import { useRecoilValue } from "recoil";
import { selectionAtom } from "../store/selection.atom";

const OriginalButton = () => {
  const { blog } = useRecoilValue(selectionAtom);

  return (
    <a
      className="flex-shrink-0 bg-rss-primary-color px-5 py-[15px] text-sm font-medium leading-[17.5px] text-white transition-all duration-300 hover:bg-rss-primary-color/70"
      href={blog?.url}
      target="_blank"
      rel="noreferrer"
    >
      VAI ALL'ARTICOLO ORIGINALE
    </a>
  );
};

export default OriginalButton;
